import { Component } from '@angular/core';

@Component({
  selector: 'kt-app-featured-services-section',
  standalone: true,
  templateUrl: './featured-services-section.component.html',
  styleUrl: './featured-services-section.component.scss'
})
export class FeaturedServicesSectionComponent {

}
